import { escapeRegExp, orderBy } from 'lodash';

import type { GenerationTool } from 'src/data/generationTool';
import type { User, UserRole } from 'src/data/user';
import type { Entity, ID } from 'src/lib/collection';

export interface Workspace extends Entity {
  name: string;
  creator: User;
  workspaceMembers: CustomerMember[];
  workspaceMembersCount: number;
  defaultTovAnalyzerForTool?: {
    generationTool: GenerationTool;
    customTovId: ID;
    customTovName: string;
  }[];
}

interface CustomerMember extends Entity {
  email: string;
  name: string | null;
  role: UserRole;
}

export const sortWorkspaces = (workspaces: Workspace[]): Workspace[] =>
  orderBy(workspaces, ['name'], ['asc']);

export const filterWorkspaces = (workspaces: Workspace[], search: string): Workspace[] => {
  if (!search) {
    return workspaces;
  }

  const regex = new RegExp(escapeRegExp(search), 'i');
  return workspaces.filter((c) => regex.test(c.name));
};

export const WORKSPACE_ACCESS_LEVEL = {
  allWorkspaces: 'allWorkspaces',
  onlyCurrentWorkspace: 'onlyCurrentWorkspace',
} as const;
export type WorkspaceAccessLevel =
  (typeof WORKSPACE_ACCESS_LEVEL)[keyof typeof WORKSPACE_ACCESS_LEVEL];

const WORKSPACE_ACCESS_LEVEL_LABEL = {
  [WORKSPACE_ACCESS_LEVEL.allWorkspaces]: 'All workspaces',
  [WORKSPACE_ACCESS_LEVEL.onlyCurrentWorkspace]: 'Only current workspace',
};

export const getWorkspaceAccessLevelLabel = (level: WorkspaceAccessLevel): string =>
  WORKSPACE_ACCESS_LEVEL_LABEL[level];
